exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.kov-modal.fade{opacity:1;margin-top:150px}div.tab-pane.fade{opacity:1}.curriculumSelectorInputGroup{display:block}.curriculumSelectorButton{width:100%;display:flex;justify-content:space-between;align-items:center}.no-selected-leerplannen{margin-left:15px}.select-all-actions{margin-top:5px;margin-bottom:5px;margin-left:15px}.select-all-actions a.select-action{color:gray!important;text-decoration:underline;cursor:pointer}", ""]);

// exports
